import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  activeTab: 'commonTasks',
  activeSubTab: {
    accommodation: 'independent',
    commonTasks: 'overview' // example default subtabs per main tab
  },
  templateActiveTab: 'common',
  templateActiveSubTab: {
    accommodation: 'independent',
    commonTasks: 'overview' // example default subtabs per main tab
  },
  formData: {}
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setActiveTab(state, action) {
      state.activeTab = action.payload;
    },
    setActiveSubTab(state, action) {
      const { mainTab, subTab } = action.payload;
      state.activeSubTab[mainTab] = subTab;
    },
    setTemplateActiveTab(state, action) {
      state.templateActiveTab = action.payload;
    },
    setTemplateActiveSubTab(state, action) {
      const { mainTab, subTab } = action.payload;
      state.templateActiveSubTab[mainTab] = subTab;
    },
    setFormData(state, action) {
      const { subTab, data } = action.payload;
      state.formData[subTab] = {
        ...state.formData[subTab],
        ...data
      };
    }
  }
});

export const {
  setActiveTab,
  setActiveSubTab,
  setFormData,
  setTemplateActiveTab,
  setTemplateActiveSubTab
} = uiSlice.actions;
export default uiSlice.reducer;
